import { ApiClient } from '../api/ApiClient';
import { ViewType, AnnouncementView } from '../types';
import { Config } from '../core/Config';

export class ViewTracker {
    private api: ApiClient;
    private config: Config;
    private onAuthError?: (error: unknown) => void;

    /**
     * @param onAuthError notified when a send fails (e.g. an expired session
     *   token), so the orchestrator can transparently recover the session
     *   instead of 401ing forever. The tracker still rethrows for the caller.
     */
    constructor(api: ApiClient, config: Config, onAuthError?: (error: unknown) => void) {
        this.api = api;
        this.config = config;
        this.onAuthError = onAuthError;
    }

    public async trackView(announcementId: string, viewType: ViewType): Promise<AnnouncementView> {
        try {
            const response = await this.api.trackView(announcementId, viewType);

            const view: AnnouncementView = {
                id: response.id,
                announcement_id: announcementId,
                view_type: viewType,
                clicked: false,
                read_seconds: 0,
                created_at: new Date().toISOString(),
            };

            this.config.log(`View tracked:`, view);

            return view;
        } catch (error) {
            this.config.error(`Failed to track view:`, error);
            this.onAuthError?.(error);
            throw error;
        }
    }
}
